/**
 * Each of these values is matched up to a value in @see DesignChannelType.
 *
 * @note Ideally we would get rid of this value along with the two mappings that it makes necessary (@see channelNameToType & @see channelTypeToName), but that would require changes in PE as well.
 *
 * @note These values should match the keys of the `SessionType` enum in the AppVersioningService repository.
 */
export enum DesignChannelName {
  email = 'EMAIL',
  facebook = 'FACEBOOK',
  instagram = 'INSTAGRAM',
  mobile = 'MOBILE',
  other = 'OTHER',
  sms = 'SMS',
  socialChat = 'SOCIAL_CHAT',
  twitter = 'TWITTER',
  voice = 'VOICE',
  webChat = 'WEB_CHAT',
  whatsApp = 'WHATSAPP'
}
